"use client"

import * as React from "react"
import { cn } from "@/lib/utils"
import { Tooltip as TooltipPrimitive } from "radix-ui"

const overlayMotion =
  "duration-[var(--dream-duration-base)] ease-[var(--dream-ease-out)] " +
  "data-[state=closed]:duration-[var(--dream-duration-exit)] data-[state=closed]:ease-[var(--dream-ease-in)] " +
  "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 " +
  "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 " +
  "data-[side=bottom]:slide-in-from-top-2 data-[state=closed]:data-[side=bottom]:slide-out-to-top-2 " +
  "data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:data-[side=top]:slide-out-to-bottom-2 " +
  "data-[side=left]:slide-in-from-right-2 data-[state=closed]:data-[side=left]:slide-out-to-right-2 " +
  "data-[side=right]:slide-in-from-left-2 data-[state=closed]:data-[side=right]:slide-out-to-left-2"

function TooltipProvider({
  delayDuration = 220,
  skipDelayDuration = 80,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      skipDelayDuration={skipDelayDuration}
      {...props}
    />
  )
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
  className,
  sideOffset = 6,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-fit max-w-[min(18rem,calc(100vw-1.5rem))] origin-(--radix-tooltip-content-transform-origin)",
          "rounded-md bg-[var(--color-ink)] px-2.5 py-1.5 text-[12px] font-medium leading-4 text-balance text-[var(--color-ink-inverse)]",
          "shadow-[var(--dream-shadow-menu)]",
          overlayMotion,
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-[var(--color-ink)] fill-[var(--color-ink)]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, overlayMotion }
